// JavaScript code for acf_blocks/programme-how-it-works-accordions component
(($) => {

    "use strict";
    if (!$('.acf-blocks-programme-how-it-works-accordions').length) {
        return
    }
    console.log("acf_blocks/programme-how-it-works-accordions scripts loaded...");

    $('.accordion > h3').on('click', function(e) {
        e.preventDefault();
        $(this).toggleClass('active');
        $(this).next('.accordion-content').slideToggle();

        $(this).closest('.accordions-container').find('.accordion').each(function() {
            if ($(this).find('h3')[0] !== e.currentTarget) {
                $(this).find('h3').removeClass('active');
                $(this).find('.accordion-content').slideUp();
                $(this).find('.plus-minus').text('+');
            }
        });

        if ($(this).hasClass('active')) {
            $(this).find('.plus-minus').text('-');
        } else {
            $(this).find('.plus-minus').text('+');
        }
    });

})(jQuery);